<template>
    <Dialog v-model:visible="visible" :modal="true" :header="header" :style="{ width: '60vw' }" @hide="reset">
        <DataTable :value="channels" :paginator="true" :rows="10" :responsiveLayout="'scroll'"
            :emptyMessage="$t('channelList.noChannels')">

            <Column :header="$t('channelList.name')">
                <template #body="slotProps">
                    {{ slotProps.data.smile }}{{ slotProps.data.name }}
                </template>
            </Column>
            <Column :header="$t('channelList.online_users')">
                <template #body="slotProps">
                    {{ slotProps.data.online }}
                </template>
            </Column>
            <Column :header="$t('channelList.channelType')">
                <template #body="slotProps">
                    <span v-html="getType(slotProps.data.type)"></span>
                </template>
            </Column>
            <Column :header="$t('channelList.owner')">
                <template #body="slotProps">
                    {{ slotProps.data.owner.nickname }}
                </template>
            </Column>



            <Column :header="$t('channelList.actions')">
                <template #body="slotProps">
                    <Button v-if="!isCurrentChannel(slotProps.data.id)" :label="$t('channelList.join')"
                        icon="pi pi-plus" @click="joinChannel(slotProps.data)" class="p-button-sm p-button-outlined" />
                </template>
            </Column>
        </DataTable>

    </Dialog>

</template>

<script>


export default {
    name: 'ChannelList',
    data() {
        return {
            visible: false,
            channels: [],
            currentChannels: [],
            header: this.$t('channelList.title')
        };
    },
    methods: {

        showTable(data, currentChannels) {
            this.channels = data.map(channel => ({
                id: channel.id,
                name: channel.name,
                type: channel.type,
                owner: channel.owner,
                smile: channel.smile,
                online: channel.online
            }));

            //sort for online count
            this.channels.sort((a, b) => b.online - a.online);

            this.currentChannels = currentChannels;
            this.visible = true;
        },

        isCurrentChannel(channelId) {
            return this.currentChannels.includes(channelId);
        },

        getType(type) {
            switch (type) {
                case 0:
                    return '<span class="p-badge p-component  p-badge-info">' + this.$t('channelList.public') + '</span>';
                case 1:
                    return '<span class="p-badge p-component  p-badge-contrast">' + this.$t('channelList.private') + '</span>';
                case 2:
                    return '<span class="p-badge p-component  p-badge-warn">' + this.$t('channelList.protected') + '</span>';
                case 3:
                    return '<span class="p-badge p-component  p-badge-danger">' + this.$t('channelList.adult') + '</span>';
                default:
                    return '<span class="p-badge p-component  p-badge-info">' + this.$t('channelList.public') + '</span>';
            }
        },

        joinChannel(channel) {

            if (channel.type == 3) {
                 this.$emit('send-events', {action: 'confirmAdultChannel', channel: channel});
                 return false;
            }
            this.$socket.emit('join', {
                id: channel.id,
                name: channel.name,
            });

            this.currentChannels.push(channel.id);
        },


        reset() {
            this.channels = [];
            this.currentChannels = [];
        }
    }
};
</script>

<style scoped></style>